enum InvoiceType {
	SALES = 'sales',
	PURCHASE = 'purchase'
}

export default InvoiceType
